/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

const CampaignVerbiage = ({ getDayVerbiage, getEndDate, displayUserType, displayFrequency, displayTime, displayStartDate, timezone }) => (
  <div className="u-width-400 c-campaign-verbiage u-text-center u-margin-auto u-mt+ u-mb+">
    This campaign will run <span>{displayFrequency}</span>{displayFrequency === 'weekly' && ' on '}<span>{getDayVerbiage()}</span> at <span>{displayTime} {timezone}</span> for <span>{displayUserType}</span> users. It will start on <span>{displayStartDate}</span> and run <span>{getEndDate()}</span>.
  </div>
);

CampaignVerbiage.propTypes = {
  getDayVerbiage: PropTypes.func.isRequired,
  getEndDate: PropTypes.func.isRequired,
  displayUserType: PropTypes.string.isRequired,
  displayFrequency: PropTypes.string.isRequired,
  displayTime: PropTypes.string.isRequired,
  displayStartDate: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired,
};

export default CampaignVerbiage;
